import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  margin-bottom: 15px;
`;

const Label = styled.div`
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
  margin-bottom: 8px;
`;

const UploadBox = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  border: 2px dashed var(--glass-border);
  border-radius: var(--radius-sm, 8px);
  background: var(--glass-1);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
  text-align: center;

  &:hover {
    border-color: var(--accent);
    background: var(--glass-2);
    color: var(--text-primary);
  }

  svg {
    width: 32px;
    height: 32px;
    margin-bottom: 10px;
    color: var(--accent);
  }
`;

const InputFile = styled.input`
  display: none;
`;

const Hint = styled.div`
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 8px;
  text-align: center;
`;

const FileUploadWidget = ({ node }) => {
  const labelText = node.content?.label || 'Dateiupload';
  const boxText = node.content?.boxText || 'Datei hierhin ziehen oder klicken';
  const hintText = node.content?.hintText || 'Max. 10MB (PDF, JPG, PNG)';

  return (
    <Wrapper width={node.style?.desktop?.width || '100%'}>
      {labelText && <Label>{labelText}</Label>}
      <UploadBox>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"></path></svg>
        <span>{boxText}</span>
        <InputFile type="file" />
      </UploadBox>
      {hintText && <Hint>{hintText}</Hint>}
    </Wrapper>
  );
};

registry.register('file_upload', {
  label: 'File Upload',
  icon: '📎',
  category: 'forms',
  defaultContent: {
    label: 'Dokument hochladen',
    boxText: 'Klicken zum Durchsuchen',
    hintText: 'PDF oder Bilder bis 5MB'
  },
  defaultStyle: {
    desktop: { width: '100%' }
  },
  render: FileUploadWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Texte',
          fields: [
            { name: 'content.label', label: 'Titel (Label)', type: 'text' },
            { name: 'content.boxText', label: 'Box Text', type: 'text' },
            { name: 'content.hintText', label: 'Hinweistext (z.B. Dateigröße)', type: 'text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.width', label: 'Breite (z.B. 100%, 300px)', type: 'text' }
          ]
        }
      ]
    }
  ]
});
